export const SITE_URL = 'https://badminton.homy.hk';

export const pages = {
  '/how-to-use': {
    slug: 'how-to-use',
    title: '如何使用羽球計分板？｜設定、計分及統計教學',
    description: '逐步了解如何設定單打或雙打比賽、選擇分數和賽制、即時計分、撤銷操作、查看發球區及比賽統計。',
    h1: '如何使用羽球計分板？',
    intro: '羽球計分板是一款免安裝的瀏覽器計分工具。選擇比賽模式並輸入球員資料後，即可在手機、平板或電腦記錄比分。',
    type: 'howto',
    sections: [
      {
        id: 'choose-mode',
        heading: '第一步如何選擇比賽模式？',
        body: '選擇單打或雙打。單打每方輸入一位球員；雙打每方可輸入兩位球員，隊名和球員名稱會顯示在比賽畫面。',
        items: [
          '選擇單打或雙打',
          '輸入兩方隊名',
          '輸入參賽球員名稱'
        ]
      },
      {
        id: 'set-format',
        heading: '如何設定分數和賽制？',
        body: '標準比賽可選擇 21 分及三局兩勝。11、15 和以 30 分為目標的選項適合練習或自訂比賽，並不代表全部是正式 BWF 賽制。',
        items: [
          '選擇 11、15、21 或 30 分',
          '選擇一局、三局或五局賽制',
          '確認設定後按「開始比賽」'
        ]
      },
      {
        id: 'score-match',
        heading: '比賽期間如何計分？',
        body: '點擊對應隊伍的比分區即可加一分。系統會更新比分、發球方、發球區、局末分及賽末分提示。',
        items: [
          '點擊左方或右方比分區加分',
          '使用撤銷功能修正上一個操作',
          '查看場地圖了解發球及接球位置'
        ]
      },
      {
        id: 'change-sides',
        heading: '比賽何時交換場區？',
        body: '每局結束後，按「下一局」時系統會交換兩方場區。標準 21 分決勝局任一方先到 11 分時亦會交換場區。',
        items: [
          '每局結束後交換場區',
          '標準 21 分決勝局先到 11 分時交換場區',
          '自訂模式的決勝局中途換邊按指定分數的一半向上取整',
          '自訂模式的中途換邊不代表正式 BWF 規則'
        ]
      },
      {
        id: 'use-tools',
        heading: '如何使用記錄、計時和統計？',
        body: '比賽工具列提供計時、得分記錄、失誤標記、手動換邊及統計。完成一局或整場比賽後亦可查看得分和比賽動量。',
        items: [
          '使用快速計時器記錄休息時間',
          '開啟記錄查看每次得分',
          '開啟統計比較兩方表現'
        ]
      }
    ]
  },
  '/badminton-rules': {
    slug: 'badminton-rules',
    title: '羽毛球計分規則｜21 分制、發球區及換邊說明',
    description: '了解羽毛球每球得分制、21 分與 30 分封頂規則、單打雙打發球區、局末分、賽末分及換邊時機。',
    h1: '羽毛球計分規則是甚麼？',
    intro: '本頁說明計分板使用的主要計分概念。正式賽事仍應以比賽主辦單位及當時有效的 BWF 規則為準。',
    sections: [
      {
        id: 'rally-scoring',
        heading: '羽毛球一局如何計分？',
        body: '標準 21 分模式採用每球得分制。任何一方贏得回合都會取得一分，並取得下一球發球權。',
        items: [
          '先到 21 分並領先兩分者勝出',
          '20 比 20 後繼續比賽，直至其中一方領先兩分',
          '29 比 29 後，先到 30 分者勝出'
        ]
      },
      {
        id: 'service-court',
        heading: '如何判斷左、右發球區？',
        body: '單打和雙打都按發球方目前分數的奇偶判斷發球區。雙打的實際輪轉仍須配合球員站位及發球次序。',
        items: [
          '發球方分數為偶數：右發球區',
          '發球方分數為奇數：左發球區',
          '接球員位於發球員的對角發球區',
          '場地圖不取代雙打實際輪轉判斷'
        ]
      },
      {
        id: 'side-change',
        heading: '羽毛球比賽甚麼時候換邊？',
        body: '每局結束後雙方交換場區。標準 21 分決勝局任一方先到 11 分時亦會交換場區。計分板在進入下一局時自動交換畫面兩方，並在決勝局中途交換時顯示提示。',
        items: [
          '每局結束後交換場區',
          '標準 21 分決勝局任一方先到 11 分時交換場區',
          '仍可使用手動換邊修正畫面位置',
          '自訂模式的中途換邊分數是產品規則，不代表正式 BWF 規則'
        ]
      },
      {
        id: 'custom-formats',
        heading: '11、15、21 和 30 分模式都符合 BWF 嗎？',
        body: '不是。標準 21 分模式使用每球得分及 30 分封頂邏輯。11、15 和以 30 分為目標的選項是工具提供的練習或自訂模式。',
        items: [
          '正式賽事請使用主辦單位指定的規則',
          '自訂模式會使用領先兩分及程式設定的封頂邏輯',
          '自訂模式的決勝局中途換邊按指定分數的一半向上取整',
          '不要把自訂模式視為正式比賽的通用規則'
        ]
      }
    ]
  },
  '/faq': {
    slug: 'faq',
    title: '羽球計分板常見問題｜離線、資料保存及賽制',
    description: '解答羽球計分板是否免費、能否離線使用、資料如何保存、支援哪些賽制，以及自訂模式是否符合正式 BWF 賽制。',
    h1: '羽球計分板常見問題',
    intro: '以下答案根據目前專案的實際功能整理。',
    type: 'faq',
    faqs: [
      {
        question: '羽球計分板需要付費或註冊嗎？',
        answer: '不需要。主要計分功能可以免費使用，也不需要建立帳戶。贊助功能是自願選項。'
      },
      {
        question: '羽球計分板可以離線使用嗎？',
        answer: '首次成功載入後，Service Worker 會在使用過程中快取頁面及建置資源。離線使用取決於瀏覽器是否已完成快取；清除網站資料後需要重新連線載入。'
      },
      {
        question: '未完成的比賽會保存多久？',
        answer: '未完成比賽會儲存在目前瀏覽器的 localStorage，最多保留 12 小時。資料不會自動同步到其他裝置。'
      },
      {
        question: '是否支援單打和雙打？',
        answer: '支援。設定頁可以選擇單打或雙打。兩種模式都會按發球方分數奇偶提示發球區；雙打實際輪轉仍須配合球員站位及發球次序。'
      },
      {
        question: '比賽何時會自動換邊？',
        answer: '按「下一局」後，系統會交換兩方場區。標準 21 分決勝局任一方先到 11 分時亦會交換場區。自訂分數模式的決勝局中途換邊使用指定分數的一半向上取整，屬產品規則。'
      },
      {
        question: '所有分數模式都符合正式 BWF 賽制嗎？',
        answer: '不是。標準 21 分模式對應每球得分和 30 分封頂邏輯；11、15 和以 30 分為目標的選項屬於練習或自訂模式。'
      },
      {
        question: '網站會收集我的比賽資料嗎？',
        answer: '目前專案沒有後端資料庫或帳戶系統。比賽及設定資料保存在目前瀏覽器；前往 Stripe 贊助頁時則適用 Stripe 自己的資料處理政策。'
      }
    ]
  },
  '/about': {
    slug: 'about',
    title: '關於羽球計分板',
    description: '了解免費羽球計分板的用途、適用對象、瀏覽器資料保存方式及聯絡網站。',
    h1: '關於羽球計分板',
    intro: '羽球計分板的目標是讓球員、教練、球會和小型比賽能快速記錄比分。',
    sections: [
      {
        id: 'what-it-is',
        heading: '這是甚麼工具？',
        body: '這是一款在瀏覽器執行的羽毛球計分工具，提供單打、雙打、發球區提示、比賽記錄、計時和統計功能。',
        items: [
          '無需建立帳戶',
          '適用於手機、平板和電腦',
          '比賽資料保存在使用者目前的瀏覽器'
        ]
      },
      {
        id: 'who-it-is-for',
        heading: '這個工具適合誰？',
        body: '工具主要為休閒球員、教練、球會、學校及小型賽事而設。正式賽事應同時遵循主辦單位及裁判的規則。',
        items: [
          '休閒及練習比賽',
          '教練和學校活動',
          '球會及小型賽事的輔助計分'
        ]
      },
      {
        id: 'contact',
        heading: '如何聯絡網站維護者？',
        body: '目前專案列出以下網站作為聯絡入口。',
        links: [
          {
            label: '前往 Homy 網站',
            href: 'https://homy.hk/'
          }
        ]
      }
    ]
  },
  '/privacy': {
    slug: 'privacy',
    title: '私隱說明｜羽球計分板的本機資料與快取',
    description: '了解羽球計分板如何在瀏覽器保存比賽和設定資料、12 小時恢復期限、Service Worker 快取及 Stripe 贊助連結。',
    h1: '羽球計分板如何處理資料？',
    intro: '本說明根據目前專案原始碼整理，說明計分工具在使用者裝置上的資料處理方式。',
    sections: [
      {
        id: 'local-storage',
        heading: '哪些資料會保存在瀏覽器？',
        body: '隊伍名稱、球員名稱、比分、賽制、得分記錄及部分設定會寫入目前瀏覽器的 localStorage。',
        items: [
          '未完成比賽最多保留 12 小時',
          '設定會保留在同一瀏覽器',
          '資料不會自動同步到其他裝置'
        ]
      },
      {
        id: 'backend',
        heading: '資料會傳送到網站資料庫嗎？',
        body: '目前專案沒有連接後端資料庫，也沒有使用者帳戶。原始碼中的比賽及設定保存功能只使用 localStorage。',
        items: [
          '沒有雲端比賽記錄',
          '沒有跨裝置同步',
          '清除瀏覽器網站資料會移除本機記錄'
        ]
      },
      {
        id: 'service-worker',
        heading: 'Service Worker 會保存甚麼？',
        body: 'Service Worker 會快取已載入的頁面、Vite 建置資源、manifest 和圖示，以支援較快的再次載入及已快取環境下的離線使用。',
        items: [
          '首次使用仍需要網路載入資源',
          '瀏覽器可自行清除快取',
          '新版本會使用新的快取名稱更新資源'
        ]
      },
      {
        id: 'payments',
        heading: '贊助付款如何處理？',
        body: '贊助按鈕會開啟 Stripe 提供的外部付款頁。本站程式碼不會儲存付款卡資料；付款資料由 Stripe 按其政策處理。',
        links: [
          {
            label: '查看 Stripe 私隱政策',
            href: 'https://stripe.com/privacy'
          }
        ]
      }
    ]
  }
};